<template>
  <div class="shipment-order-container">
    <!-- 搜索区域 -->
    <div class="search-section">
      <el-button type="primary" @click="handleCreate" icon="el-icon-plus" size="small">{{
        $t("admin.ShipmentOrder.833446-0")
      }}</el-button>
      <div class="search-form">
        <el-input
          v-model="searchForm.orderNo"
          :placeholder="$t('admin.ShipmentOrder.833446-1')"
          clearable
          style="width: 200px; margin-right: 10px"
          size="small"
        />
        <el-input
          v-model="searchForm.userName"
          :placeholder="$t('admin.ShipmentOrder.833446-2')"
          clearable
          style="width: 200px; margin-right: 10px"
          size="small"
        />
        <el-input
          v-model="searchForm.equipmentNo"
          :placeholder="$t('admin.ShipmentOrder.833446-3')"
          clearable
          style="width: 200px; margin-right: 10px"
          size="small"
        />
        <el-button type="primary" @click="handleSearch" icon="el-icon-search" size="small">{{
          $t("admin.ShipmentOrder.833446-4")
        }}</el-button>
        <el-button @click="handleReset" icon="el-icon-refresh" size="small">{{
          $t("admin.ShipmentOrder.833446-5")
        }}</el-button>
      </div>
    </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <el-table v-loading="loading" :data="tableData" border stripe style="width: 100%" @sort-change="handleSortChange">
        <el-table-column prop="orderNo" :label="$t('admin.ShipmentOrder.833446-1')" width="180" />
        <el-table-column prop="userName" :label="$t('admin.ShipmentOrder.833446-6')" width="200" />
        <el-table-column
          prop="equipmentCount"
          :label="$t('admin.ShipmentOrder.833446-7')"
          width="120"
          sortable="custom"
          align="center"
        />
        <el-table-column prop="createTime" :label="$t('admin.ShipmentOrder.833446-8')" width="180" sortable="custom" />
        <el-table-column
          prop="notes"
          :label="$t('admin.ShipmentOrder.833446-9')"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column :label="$t('admin.ShipmentOrder.833446-10')" min-width="170" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="handleEdit(scope.row)">{{
              $t("admin.ShipmentOrder.833446-11")
            }}</el-button>
            <el-button type="primary" size="mini" @click="handleView(scope.row)">{{
              $t("admin.ShipmentOrder.833446-12")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageIndex"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          background
        />
      </div>
    </div>

    <!-- {{ $t('admin.ShipmentOrder.833446-0') }}/编辑订单弹窗 -->
    <CreateOrderDialog :visible.sync="createDialogVisible" :form-data="currentOrder" @success="handleDialogSuccess" />

    <!-- 查看订单详情弹窗 -->
    <OrderDetailDialog :visible.sync="detailDialogVisible" :order-id="currentOrderId" :order-info="currentOrder" />
  </div>
</template>

<script>
  import CreateOrderDialog from "./components/CreateOrderDialog.vue";
  import OrderDetailDialog from "./components/OrderDetailDialog.vue";

  export default {
    name: "ShipmentOrder",
    components: {
      CreateOrderDialog,
      OrderDetailDialog
    },
    data() {
      return {
        loading: false,
        tableData: [],
        searchForm: {
          orderNo: "",
          userName: "",
          equipmentNo: ""
        },
        pagination: {
          pageIndex: 1,
          pageSize: 10,
          total: 0
        },
        sortConfig: {
          column: "",
          asc: true
        },
        createDialogVisible: false,
        detailDialogVisible: false,
        currentOrder: null,
        currentOrderId: ""
      };
    },
    mounted() {
      this.loadData();
    },
    methods: {
      // 加载数据
      loadData() {
        this.loading = true;
        const params = {
          pageIndex: this.pagination.pageIndex,
          pageSize: this.pagination.pageSize,
          orderNo: this.searchForm.orderNo || undefined,
          userName: this.searchForm.userName || undefined
        };

        // 添加排序参数
        if (this.sortConfig.column) {
          params.orders = [
            {
              column: this.sortConfig.column,
              asc: this.sortConfig.asc
            }
          ];
        }

        this.$api
          .request(this.$url.ShippingOrder.page, this.$method.get, params)
          .then(res => {
            if (res.code === 0) {
              this.tableData = res.data.records || [];
              this.pagination.total = +res.data.total || 0;
            } else {
              this.$message.error(res.msg || this.$t("admin.ShipmentOrder.833446-13"));
            }
          })
          .catch(err => {
            this.$message.error(this.$t("admin.ShipmentOrder.833446-14"));
          })
          .finally(() => {
            this.loading = false;
          });
      },

      // 搜索
      handleSearch() {
        this.pagination.pageIndex = 1;
        this.loadData();
      },

      // 重置
      handleReset() {
        this.searchForm = {
          orderNo: "",
          userName: "",
          equipmentNo: ""
        };
        this.sortConfig = {
          column: "",
          asc: true
        };
        this.pagination.pageIndex = 1;
        this.loadData();
      },

      // 创建订单
      handleCreate() {
        this.currentOrder = null;
        this.createDialogVisible = true;
      },

      // 查看订单详情
      handleView(row) {
        this.currentOrderId = row.id;
        this.currentOrder = row;
        this.detailDialogVisible = true;
      },

      // 编辑订单
      handleEdit(row) {
        this.currentOrder = row;
        this.createDialogVisible = true;
      },

      // 弹窗成功回调
      handleDialogSuccess() {
        this.loadData();
      },

      // 分页大小改变
      handleSizeChange(val) {
        this.pagination.pageSize = val;
        this.pagination.pageIndex = 1;
        this.loadData();
      },

      // 当前页改变
      handleCurrentChange(val) {
        this.pagination.pageIndex = val;
        this.loadData();
      },

      // 排序改变
      handleSortChange({ prop, order }) {
        if (order) {
          this.sortConfig = {
            column: prop,
            asc: order === "ascending"
          };
        } else {
          this.sortConfig = {
            column: "",
            asc: true
          };
        }
        this.loadData();
      }
    }
  };
</script>

<style scoped lang="scss">
  .shipment-order-container {
    padding: 20px;
    background-color: var(--vtm-surface);
    min-height: calc(100vh - 100px);

    .search-section {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-wrap: wrap;
      gap: 12px;
      margin-bottom: 20px;

      .search-form {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
      }
    }

    .table-section {
      .pagination-section {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
</style>
